import axios from '@/libs/axios'

const API_URL = '/ProgramacionAcademica'

export default {
  // Obtener todas las programaciones académicas
  async getAll() {
    try {
      const response = await axios.get(API_URL)
      return response.data
    } catch (error) {
      console.error('Error fetching programaciones:', error)
      throw error
    }
  },

  // Obtener una programación académica por ID
  async getById(id) {
    try {
      const response = await axios.get(`${API_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching programacion ${id}:`, error)
      throw error
    }
  },

  // Obtener programaciones por tipo de plan
  async getByTipoPlan(tipoPlanId) {
    try {
      const response = await axios.get(`${API_URL}/ByTipoPlan/${tipoPlanId}`)
      return response.data
    } catch (error) {
      console.error(`Error fetching programaciones for tipo plan ${tipoPlanId}:`, error)
      throw error
    }
  },

  // Crear una programación académica
  async create(programacion) {
    try {
      const response = await axios.post(API_URL, programacion)
      return response.data
    } catch (error) {
      console.error('Error creating programacion:', error)
      throw error
    }
  },

  // Actualizar una programación académica
  async update(id, programacion) {
    try {
      const response = await axios.put(`${API_URL}/${id}`, programacion)
      return response.data
    } catch (error) {
      console.error(`Error updating programacion ${id}:`, error)
      throw error
    }
  },

  // Eliminar una programación académica
  async delete(id) {
    try {
      const response = await axios.delete(`${API_URL}/${id}`)
      return response.data
    } catch (error) {
      console.error(`Error deleting programacion ${id}:`, error)
      throw error
    }
  },
}

